@if (isVisible) {
  <div class="outageWarningContainer">
    <div class="outageWarning">
      @if (showSpinner) {
        <span class="spinner"></span>
      }
      <div class="content">
        <div [innerHTML]="message"></div>
      </div>
      @if (showSupportLink) {
        <div (click)="actionButtonClicked()" class="support-link">{{ buttonText }}</div>
      }
      <div (click)="close()" class="miniClose"></div>
    </div>
  </div>
}
